export const getMiniCardDetailsParams = (props) => {
    return {
        event: props.event,
        handlers: props.handlers,
        showFavorites: props.isFavoritesEnabled,
        hideGameState: props.hideGameState,
        dict: props.dict
    };
};
//# sourceMappingURL=getMiniCardDetailsParams.js.map